module.exports = __webpack_public_path__ + "./kit/docs/img/stackoverflow.f163674ca17daf78a7355f50723460ab.svg";